import s from "./index694.js";
import { withInstallFunction as e } from "./index604.js";
const a = e(s, "$message");
export {
  a as ElMessage,
  a as default
};
